$(window).scroll(function() {
  $('[data-animation]').each(function() {
    var pos = $(this).offset().top
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    if (scroll > pos - windowHeight + windowHeight / 4) {
      $(this).addClass('is-animated')
    }
  })
})
